/* eslint-disable @direct-frontend/modules/slice-boundaries -- характеристики нужны для преобразования маппинга в теги */
import { useMemo } from 'react';
import { useCharacteristicsGetAll } from '#entities/characteristic';
import { type OpenApiSchemaMapping } from '#shared/api/schema';
import { type TagWithScope } from '#shared/lib/integrations';
import { mapMappingToTags } from '../lib/mapMappingToTags';

export const useIntegrationMappingTags = ({ mapping }: { mapping?: OpenApiSchemaMapping }): TagWithScope[] => {
    const { data: characteristics } = useCharacteristicsGetAll({});

    return useMemo(() => mapMappingToTags(mapping, characteristics ?? []), [characteristics, mapping]);
};
